import { useCallback } from "react";
import { createRoute, useNavigate } from "@tanstack/react-router";
import { TasksStatus, TasksView, tasksSearchSchema, type TasksSearch } from "@amber/operations/ui";
import { AppFrame } from "../shell/AppFrame";
import { usePageTitle } from "../shell/title";
import { rootRoute } from "./root";

function TasksRoute({ search, taskId }: { search: TasksSearch; taskId: string | null }) {
  usePageTitle("Tasks");
  const navigate = useNavigate();
  const onSearch = useCallback(
    (next: TasksSearch) => {
      void navigate({ to: taskId ? "/tasks/$taskId" : "/tasks", params: taskId ? { taskId } : {}, search: next });
    },
    [navigate, taskId],
  );
  const onOpenTask = useCallback(
    (id: string | null) => {
      if (id) void navigate({ to: "/tasks/$taskId", params: { taskId: id }, search });
      else void navigate({ to: "/tasks", search });
    },
    [navigate, search],
  );
  return (
    <AppFrame view="Tasks" status={<TasksStatus />}>
      {() => <TasksView search={search} taskId={taskId} onSearch={onSearch} onOpenTask={onOpenTask} />}
    </AppFrame>
  );
}

export const tasksRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/tasks",
  validateSearch: tasksSearchSchema,
  component: function TasksListRoute() {
    return <TasksRoute search={tasksRoute.useSearch()} taskId={null} />;
  },
});

export const taskRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/tasks/$taskId",
  validateSearch: tasksSearchSchema,
  component: function TaskDetailRoute() {
    return <TasksRoute search={taskRoute.useSearch()} taskId={taskRoute.useParams().taskId} />;
  },
});
